import DOMPurify from "dompurify";

const config = {
    selectors: {
        dropdown: '.eifu-form__wrapper .mdc-select',
        list: '.mdc-select__menu',
        languageDropdown: '#language',
    },
};

function init() {
    $(config.selectors.dropdown).each((i, el) => {
        const $dropdown = $(el);
        initDropDown($dropdown);
    });

    $(config.selectors.list).each((i, el) => {
        const $list = $(el);
        //  console.log('list: ', $list);
        initList($list);
    });
}

function initList($list) {
    $list.on('click', (e) => {
        // console.log('click list');
        e.preventDefault();
    });

    if($('.dropdown-menu').hasClass('open')) {
        $('body').addClass('no-scroll')
    }else {
        $('body').removeClass('no-scroll')
    }
}

function initDropDown($dropdown) {
    function handleDropdownChange(value) {
        const versionChanged = $dropdown.attr('data-selected') !== value;
        const type = $dropdown.attr('data-selector');
        const url = new URL(window.location.href);
        const id = url.searchParams.get('id') || '';
        const q = url.searchParams.get('q') || '';
        const query = id !== '' ? DOMPurify.sanitize(id) : DOMPurify.sanitize(q);
        const language = DOMPurify.sanitize(url.searchParams.get('language')) || '';
        const country = DOMPurify.sanitize(url.searchParams.get('country')) || '';
        const specialty = DOMPurify.sanitize(url.searchParams.get('specialty')) || '';

        // console.log('language before sanitize: ', url.searchParams.get('language'));
        // console.log('language after sanitize: ', DOMPurify.sanitize(url.searchParams.get('language')));

        // console.log('country before sanitize: ', url.searchParams.get('country'));
        // console.log('country after sanitize: ', DOMPurify.sanitize(url.searchParams.get('country')));


        let newURL = `${window.location.origin + window.location.pathname}?q=${query}&${type}=${value}`;

        if (!versionChanged) {
            return;
        }

        if (type === 'specialty' && value !== '') {
            newURL = `${window.location.origin + window.location.pathname}?id=${query}&${type}=${value}`;
            newURL += language !== '' ? '&language=' + language : '';
            newURL += country !== '' ? '&country=' + country : '';
            window.location.href = newURL;
        } else if (type === 'country' && value !== '') {
            newURL += language !== '' ? '&language=' + language : '';
            newURL += specialty !== '' ? '&specialty=' + specialty : '';
            window.location.href = newURL;
        } else if (type === 'language' && value !== '') {
            newURL += country !== '' ? '&country=' + country : '';
            newURL += specialty !== '' ? '&specialty=' + specialty : '';
            window.location.href = newURL;
        }
    }

    $dropdown.on('MDCSelect:change', (e) => {
        // console.log('click');

        e.preventDefault();

        const { originalEvent: { detail: { value } } } = e;
        handleDropdownChange(value);
    });
}

if (document.querySelectorAll('.eifu').length > 0) {
    init();
}
